define('viewmodels/pages/player/settings/phoneNumberChange',[
    'knockout',
    'underscore',
    'plugins/dialog'
], function (ko, _, dialog) {

    var PhoneNumberChangeViewModel = function (
        player,
        settingsModel,
        ChangeMobileNumberDialog,
        VerifyMobileNumberDialog,
        wpVerifyMobileNumber,
        navigation
    ) {
        var self = this;

        self.player = player.peek();
        self.phoneVerificationStatus = player().phoneNumberVerified();
        self.contactInfo = self.player.contactInfo;

        self.translations = {
            title: wpVerifyMobileNumber('phone_change_title'),
            buttonVerify: wpVerifyMobileNumber('button_verify'),
            buttonChange: wpVerifyMobileNumber('button_change'),
            question: wpVerifyMobileNumber('phone_correct_question'),
            buttonBack: wpVerifyMobileNumber('back_to_settings_button')
        };

        self.question = self.translations.question.replacements({
            phoneNumber: self.contactInfo.phoneNumber.displayValue
        });

        self.showChangeMobileNumberDialog = function () {
            dialog.showDialog(new ChangeMobileNumberDialog());
        };

        self.startVerificationProcess = function () {
            settingsModel.createVerificationCodeRequestCommand({
                phoneNumber: {
                    prefix: self.contactInfo.phoneNumber.prefix,
                    number: self.contactInfo.phoneNumber.number
                }
            }).dispatch().then(function () {
                dialog.showDialog(new VerifyMobileNumberDialog());
            });
        };

        self.navigateBack = function () {
            if (navigation.canGoBack()) {
                navigation.goBack();
            } else {
                navigation.navigate(navigation.ROUTES.SETTINGS);
            }
        };

    };

    return PhoneNumberChangeViewModel;
});


